import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiInstagram, FiCalendar } from 'react-icons/fi';

const artistsData = [
  {
    id: 'alex',
    name: 'Alex Mercer',
    role: 'Blackwork Specialist',
    experience: '8 Years',
    bio: "Alex brings a dark, architectural approach to blackwork. Drawing heavily from gothic architecture, sacred geometry, and dark surrealism, his pieces are bold, high-contrast, and designed to flow perfectly with the body's natural lines. Originally from Berlin, he has made Montreal his canvas for the past 5 years.",
    styles: ['Blackwork', 'Geometric', 'Dark Surrealism'],
    img: 'https://images.unsplash.com/photo-1531891437562-4301cf35b7e4?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'sofia',
    name: 'Sofia Reyes',
    role: 'Fine Line Artist',
    experience: '5 Years',
    bio: "Specializing in single-needle and fine line work, Sofia creates delicate, intricate designs that look like they were sketched onto the skin with a sharp pencil. Her background in classical illustration allows her to create micro-realism, elegant floral pieces, and crisp typography that stand the test of time.",
    styles: ['Fine Line', 'Micro Realism', 'Floral', 'Typography'],
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'jordan',
    name: 'Jordan Blake',
    role: 'Realism Artist',
    experience: '12 Years',
    bio: "Jordan's mastery of black and grey realism is unmatched. Whether it's a portrait of a loved one, wildlife, or complex cinematic scenes, his shading techniques create depth that makes the tattoo appear 3D. He spends hours in consultation ensuring reference photos will translate perfectly to skin.",
    styles: ['B&G Realism', 'Portraits', 'Wildlife'],
    img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=800'
  },
  {
    id: 'maya',
    name: 'Maya Stone',
    role: 'Traditional Specialist',
    experience: '10 Years',
    bio: "Bold will hold. Maya is our resident expert in American Traditional and Neo-Traditional tattoos. With solid black outlines, heavy color saturation, and classic motifs, her work pays homage to tattoo history while adding modern technical application for a cleaner, brighter heal.",
    styles: ['American Traditional', 'Neo-Traditional', 'Japanese'],
    img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=800'
  }
];

const Artists = () => {
  return (
    <div className="pt-24 pb-20 bg-background min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-20"
        >
          <h1 className="text-4xl md:text-6xl font-display mb-6">Our Artists</h1>
          <div className="w-20 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-muted max-w-2xl mx-auto">
            A collective of dedicated professionals, each mastering their unique style to bring your ideas to life.
          </p>
        </motion.div>

        <div className="space-y-32">
          {artistsData.map((artist, idx) => (
            <motion.div 
              key={artist.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7 }}
              className={`flex flex-col ${idx % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-20 items-center`}
            >
              <div className="w-full lg:w-1/2">
                <div className="relative group">
                  <div className="absolute inset-0 bg-secondary translate-x-4 translate-y-4 group-hover:translate-x-6 group-hover:translate-y-6 transition-transform duration-500"></div>
                  <img src={artist.img} alt={artist.name} className="relative z-10 w-full aspect-[4/5] object-cover grayscale hover:grayscale-0 transition-all duration-700" />
                </div>
              </div>
              
              <div className="w-full lg:w-1/2 space-y-6">
                <div>
                  <h2 className="text-4xl font-display text-light mb-2">{artist.name}</h2>
                  <p className="text-xl text-secondary font-medium">{artist.role}</p>
                </div>
                
                <div className="flex gap-4 text-sm text-muted">
                  <span className="px-3 py-1 bg-primary border border-gray-800 rounded-full">Experience: {artist.experience}</span>
                </div>

                <p className="text-muted leading-relaxed text-lg">
                  {artist.bio}
                </p>

                <div>
                  <h4 className="text-light font-medium mb-3">Specialties:</h4>
                  <div className="flex flex-wrap gap-2">
                    {artist.styles.map(style => (
                      <span key={style} className="px-4 py-2 bg-primary text-sm text-light">
                        {style}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="pt-6 flex flex-wrap gap-4">
                  <Link to={`/booking?artist=${artist.id}`} className="flex items-center gap-2 bg-light text-primary px-6 py-3 font-medium hover:bg-secondary transition-colors uppercase tracking-wider text-sm">
                    <SafeIcon icon={FiCalendar} /> Book {artist.name.split(' ')[0]}
                  </Link>
                  <a href="#" className="flex items-center gap-2 border border-gray-600 text-light px-6 py-3 hover:border-secondary hover:text-secondary transition-colors uppercase tracking-wider text-sm">
                    <SafeIcon icon={FiInstagram} /> Instagram
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Artists;